//   http://localhost:4000  https://quoratrafficopsbackend-297709095640.europe-west1.run.app
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://quoratrafficopsbackend-297709095640.europe-west1.run.app'
});

export default instance;